import { render } from "./EditPageContentEdit.vue?vue&type=template&id=20bba234&scoped=true"
import script from "./EditPageContentEdit.vue?vue&type=script&lang=js"
export * from "./EditPageContentEdit.vue?vue&type=script&lang=js"

import "./EditPageContentEdit.vue?vue&type=style&index=0&id=20bba234&lang=scss"
import "./EditPageContentEdit.vue?vue&type=style&index=1&id=20bba234&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bba234"]])

export default __exports__